// @flow
import type {TGroupedTranslationList, TLanguageList} from '@userstory/i18n';
import type {HttpService} from 'modules/common/services/http';
import type {TResponse} from 'types';

/**
 * Сервис для работы с языками и переводами
 */
export class IntlApi {
    /**
     * Сервис для отправки HTTP запросов
     */
    _http: HttpService;

    /**
     * @param http Сервис для отправки HTTP запросов
     */
    constructor(http: HttpService) {
        this._http = http;
    }

    /**
     * Загружает языки приложения
     * @returns языки приложения
     */
    async loadLanguageList(): TResponse<TLanguageList> {
        return this._http.get<TLanguageList>('/language');
    }

    /**
     * Загружает переводы приложения
     * @param languageKey код языка
     * @returns переводы приложения
     */
    async loadTranslations(languageKey: string): TResponse<TGroupedTranslationList> {
        const response = await this._http.post<TGroupedTranslationList>(`/translation`, {
            body: {
                'filter[url]': languageKey,
            },
            extraOptions: {
                dataType: 'FORM_DATA',
            },
            options: {
                headers: {
                    'X-http-method-override': 'POST',
                },
            },
        });
        if (response.success) {
            return {
                data: response.data.list,
                success: true,
            };
        }
        return {errors: {}, success: false};
    }
}
